import type {
  EntityAction,
} from '../types';

import * as actionTypes from './actionTypes';

export const requestMessages = ({ id, qs } = {}): EntityAction => ({
  type: actionTypes.REQUEST_MESSAGES,
  id,
  qs,
});

export const requestConversationList = ({ userId, callbacks } = {}): EntityAction => ({
  type: actionTypes.REQUEST_CONVERSATION_LIST,
  userId,
  callbacks,
});

export const requestUnreadCategories = ({ id } = {}): EntityAction => ({
  type: actionTypes.REQUEST_UNREAD_CATEGORIES,
  id,
});

export const requestMarkReadMessages = ({
  ids,
  conversationId,
} = {}): EntityAction => ({
  type: actionTypes.REQUEST_MARK_READ_MESSAGES,
  ids,
  conversationId,
});
